<template>
  <input-text
    :required="required"
    :label="label"
    v-model="model"
    v-mask="'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX'"
    :disabled="disabled"
  />
</template>

<script>
export default {
  props: {
    value: null,
    label: { default: "EVP" },
    required: { default: false },
    disabled: { default: false },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
    